/**
 * @file Generic Button Component.
 */

import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';

import Button from './Button';

const propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  tooltipProps: PropTypes.object,
  tip: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  tooltipId: PropTypes.string.isRequired,
};

const TooltipButton = ({
  children,
  tooltipProps = {},
  tip,
  tooltipId,
  ...props
}) => {
  return (
    <>
      <Button
        data-effect="solid"
        data-place="left"
        {...props}
        data-for={tooltipId}
        data-tip
      >
        {children}
      </Button>
      {tip && (
        <ReactTooltip
          className="tooltip"
          globalEventOff="click"
          id={tooltipId}
          {...tooltipProps}
        >
          {tip}
        </ReactTooltip>
      )}
    </>
  );
};

TooltipButton.propTypes = propTypes;

export default TooltipButton;
